// extracted by mini-css-extract-plugin
export var color_black = "Product-module--color_black--921ac";
export var color_blue = "Product-module--color_blue--60894";
export var color_green = "Product-module--color_green--498d4";
export var color_lightblue = "Product-module--color_lightblue--f29a8";
export var color_orange = "Product-module--color_orange--6bcd9";
export var color_red = "Product-module--color_red--6f77e";
export var color_white = "Product-module--color_white--0f13c";
export var color_yellow = "Product-module--color_yellow--41a74";
export var container = "Product-module--container--6d216";
export var container_allCategories = "Product-module--container_allCategories--5359f";
export var container_categories = "Product-module--container_categories--328ce";
export var container_section = "Product-module--container_section--62429";
export var products__container = "Product-module--products__container--7b1ec";
export var products__title = "Product-module--products__title--13124";
export var text = "Product-module--text--ad310";